/*eslint-disable */

// INFOBOXJS
function InfoBox(t) {
  t = t || {}, google.maps.OverlayView.apply(this, arguments), this.content_ = t.content || "", this.disableAutoPan_ = t.disableAutoPan || !1, this.maxWidth_ = t.maxWidth || 0, this.pixelOffset_ = t.pixelOffset || new google.maps.Size(0, 0), this.position_ = t.position || new google.maps.LatLng(0, 0), this.zIndex_ = t.zIndex || null, this.boxClass_ = t.boxClass || "infoBox", this.boxStyle_ = t.boxStyle || {}, this.closeBoxMargin_ = t.closeBoxMargin || "2px", this.closeBoxURL_ = t.closeBoxURL || "http://www.google.com/intl/en_us/mapfiles/close.gif", "" === t.closeBoxURL && (this.closeBoxURL_ = ""), this.infoBoxClearance_ = t.infoBoxClearance || new google.maps.Size(1, 1), this.isHidden_ = t.isHidden || !1, this.alignBottom_ = t.alignBottom || !1, this.pane_ = t.pane || "floatPane", this.enableEventPropagation_ = t.enableEventPropagation || !1, this.div_ = null, this.closeListener_ = null, this.eventListener1_ = null, this.eventListener2_ = null, this.eventListener3_ = null, this.moveListener_ = null, this.contextListener_ = null, this.fixedWidthSet_ = null
}
InfoBox.prototype = new google.maps.OverlayView, InfoBox.prototype.createInfoBoxDiv_ = function () {
  var t, e = this,
    i = function (t) {
      t.cancelBubble = !0, t.stopPropagation && t.stopPropagation()
    };
  this.div_ || (this.div_ = document.createElement("div"), this.setBoxStyle_(), void 0 === this.content_.nodeType ? this.div_.innerHTML = this.getCloseBoxImg_() + this.content_ : (this.div_.innerHTML = this.getCloseBoxImg_(), this.div_.appendChild(this.content_)), this.getPanes()[this.pane_].appendChild(this.div_), this.addClickHandler_(), this.div_.style.width ? this.fixedWidthSet_ = !0 : 0 !== this.maxWidth_ && this.div_.offsetWidth > this.maxWidth_ ? (this.div_.style.width = this.maxWidth_, this.div_.style.overflow = "auto", this.fixedWidthSet_ = !0) : (t = this.getBoxWidths_(), this.div_.style.width = this.div_.offsetWidth - t.left - t.right + "px", this.fixedWidthSet_ = !1), this.panBox_(this.disableAutoPan_), this.enableEventPropagation_ || (this.eventListener1_ = google.maps.event.addDomListener(this.div_, "mousedown", i), this.eventListener2_ = google.maps.event.addDomListener(this.div_, "click", i), this.eventListener3_ = google.maps.event.addDomListener(this.div_, "dblclick", i), this.eventListener4_ = google.maps.event.addDomListener(this.div_, "mouseover", function (t) {
    this.style.cursor = "default"
  })), this.contextListener_ = google.maps.event.addDomListener(this.div_, "contextmenu", function (t) {
    t.returnValue = !1, t.preventDefault && t.preventDefault(), e.enableEventPropagation_ || i(t)
  }), google.maps.event.trigger(this, "domready"))
}, InfoBox.prototype.getCloseBoxImg_ = function () {
  var t = "";
  return "" !== this.closeBoxURL_ && (t = "<img", t += " src='" + this.closeBoxURL_ + "'", t += " align=right", t += " style='", t += " position: relative;", t += " cursor: pointer;", t += " margin: " + this.closeBoxMargin_ + ";", t += "'>"), t
}, InfoBox.prototype.addClickHandler_ = function () {
  var t;
  "" !== this.closeBoxURL_ ? (t = this.div_.firstChild, this.closeListener_ = google.maps.event.addDomListener(t, "click", this.getCloseClickHandler_())) : this.closeListener_ = null
}, InfoBox.prototype.getCloseClickHandler_ = function () {
  var e = this;
  return function (t) {
    t.cancelBubble = !0, t.stopPropagation && t.stopPropagation(), setTimeout(function () {
      e.close()
    }, 350), google.maps.event.trigger(e, "closeclick")
  }
}, InfoBox.prototype.panBox_ = function (t) {
  var e, i = 0,
    o = 0;
  if (!t && (e = this.getMap()) instanceof google.maps.Map) {
    e.getBounds().contains(this.position_) || e.setCenter(this.position_), e.getBounds();
    var s = e.getDiv(),
      n = s.offsetWidth,
      h = s.offsetHeight,
      l = this.pixelOffset_.width,
      d = this.pixelOffset_.height,
      r = this.div_.offsetWidth,
      a = this.div_.offsetHeight,
      _ = this.infoBoxClearance_.width,
      p = this.infoBoxClearance_.height,
      v = this.getProjection().fromLatLngToContainerPixel(this.position_);
    if (v.x < -l + _ ? i = v.x + l - _ : v.x + r + l + _ > n && (i = v.x + r + l + _ - n), this.alignBottom_ ? v.y < -d + p + a ? o = v.y + d - p - a : v.y + d + p > h && (o = v.y + d + p - h) : v.y < -d + p ? o = v.y + d - p : v.y + a + d + p > h && (o = v.y + a + d + p - h), 0 !== i || 0 !== o) {
      e.getCenter();
      e.panBy(i, o)
    }
  }
}, InfoBox.prototype.setBoxStyle_ = function () {
  var t, e;
  if (this.div_) {
    for (t in this.div_.className = this.boxClass_, this.div_.style.cssText = "", e = this.boxStyle_) e.hasOwnProperty(t) && (this.div_.style[t] = e[t]);
    void 0 !== this.div_.style.opacity && "" !== this.div_.style.opacity && (this.div_.style.filter = "alpha(opacity=" + 100 * this.div_.style.opacity + ")"), this.div_.style.position = "absolute", this.div_.style.visibility = "hidden", null !== this.zIndex_ && (this.div_.style.zIndex = this.zIndex_)
  }
}, InfoBox.prototype.getBoxWidths_ = function () {
  var t, e = {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0
    },
    i = this.div_;
  return document.defaultView && document.defaultView.getComputedStyle ? (t = i.ownerDocument.defaultView.getComputedStyle(i, "")) && (e.top = parseInt(t.borderTopWidth, 10) || 0, e.bottom = parseInt(t.borderBottomWidth, 10) || 0, e.left = parseInt(t.borderLeftWidth, 10) || 0, e.right = parseInt(t.borderRightWidth, 10) || 0) : document.documentElement.currentStyle && i.currentStyle && (e.top = parseInt(i.currentStyle.borderTopWidth, 10) || 0, e.bottom = parseInt(i.currentStyle.borderBottomWidth, 10) || 0, e.left = parseInt(i.currentStyle.borderLeftWidth, 10) || 0, e.right = parseInt(i.currentStyle.borderRightWidth, 10) || 0), e
}, InfoBox.prototype.onRemove = function () {
  this.div_ && (this.div_.parentNode.removeChild(this.div_), this.div_ = null)
}, InfoBox.prototype.draw = function () {
  this.createInfoBoxDiv_();
  var t = this.getProjection().fromLatLngToDivPixel(this.position_);
  this.div_.style.left = t.x + this.pixelOffset_.width + "px", this.alignBottom_ ? this.div_.style.bottom = -(t.y + this.pixelOffset_.height) + "px" : this.div_.style.top = t.y + this.pixelOffset_.height + "px", this.isHidden_ ? this.div_.style.visibility = "hidden" : this.div_.style.visibility = "visible"
}, InfoBox.prototype.setOptions = function (t) {
  void 0 !== t.boxClass && (this.boxClass_ = t.boxClass, this.setBoxStyle_()), void 0 !== t.boxStyle && (this.boxStyle_ = t.boxStyle, this.setBoxStyle_()), void 0 !== t.content && this.setContent(t.content), void 0 !== t.disableAutoPan && (this.disableAutoPan_ = t.disableAutoPan), void 0 !== t.maxWidth && (this.maxWidth_ = t.maxWidth), void 0 !== t.pixelOffset && (this.pixelOffset_ = t.pixelOffset), void 0 !== t.alignBottom && (this.alignBottom_ = t.alignBottom), void 0 !== t.position && this.setPosition(t.position), void 0 !== t.zIndex && this.setZIndex(t.zIndex), void 0 !== t.closeBoxMargin && (this.closeBoxMargin_ = t.closeBoxMargin), void 0 !== t.closeBoxURL && (this.closeBoxURL_ = t.closeBoxURL), void 0 !== t.infoBoxClearance && (this.infoBoxClearance_ = t.infoBoxClearance), void 0 !== t.isHidden && (this.isHidden_ = t.isHidden), void 0 !== t.enableEventPropagation && (this.enableEventPropagation_ = t.enableEventPropagation), this.div_ && this.draw()
}, InfoBox.prototype.setContent = function (t) {
  this.content_ = t, this.div_ && (this.closeListener_ && (google.maps.event.removeListener(this.closeListener_), this.closeListener_ = null), this.fixedWidthSet_ || (this.div_.style.width = ""), void 0 === t.nodeType ? this.div_.innerHTML = this.getCloseBoxImg_() + t : (this.div_.innerHTML = this.getCloseBoxImg_(), this.div_.appendChild(t)), this.fixedWidthSet_ || (this.div_.style.width = this.div_.offsetWidth + "px", void 0 === t.nodeType ? this.div_.innerHTML = this.getCloseBoxImg_() + t : (this.div_.innerHTML = this.getCloseBoxImg_(), this.div_.appendChild(t))), this.addClickHandler_()), google.maps.event.trigger(this, "content_changed")
}, InfoBox.prototype.setPosition = function (t) {
  this.position_ = t, this.div_ && this.draw(), google.maps.event.trigger(this, "position_changed")
}, InfoBox.prototype.setZIndex = function (t) {
  this.zIndex_ = t, this.div_ && (this.div_.style.zIndex = t), google.maps.event.trigger(this, "zindex_changed")
}, InfoBox.prototype.getContent = function () {
  return this.content_
}, InfoBox.prototype.getPosition = function () {
  return this.position_
}, InfoBox.prototype.getZIndex = function () {
  return this.zIndex_
}, InfoBox.prototype.show = function () {
  this.isHidden_ = !1, this.div_ && (this.div_.style.visibility = "visible")
}, InfoBox.prototype.hide = function () {
  this.isHidden_ = !0, this.div_ && (this.div_.style.visibility = "hidden")
}, InfoBox.prototype.open = function (t, e) {
  var i = this;
  e && (this.position_ = e.getPosition(), this.moveListener_ = google.maps.event.addListener(e, "position_changed", function () {
    i.setPosition(this.getPosition())
  })), this.setMap(t), this.div_ && this.panBox_()
}, InfoBox.prototype.close = function () {
  this.closeListener_ && (google.maps.event.removeListener(this.closeListener_), this.closeListener_ = null), this.eventListener1_ && (google.maps.event.removeListener(this.eventListener1_), google.maps.event.removeListener(this.eventListener2_), google.maps.event.removeListener(this.eventListener3_), google.maps.event.removeListener(this.eventListener4_), this.eventListener1_ = null, this.eventListener2_ = null, this.eventListener3_ = null, this.eventListener4_ = null), this.moveListener_ && (google.maps.event.removeListener(this.moveListener_), this.moveListener_ = null), this.contextListener_ && (google.maps.event.removeListener(this.contextListener_), this.contextListener_ = null), this.setMap(null)
};

// RICHMARKER JS

(function () {
  var b = true,
    f = false;

  function g(a) {
    var c = a || {};
    this.d = this.c = f;
    if (a.visible == undefined) a.visible = b;
    if (a.shadow == undefined) a.shadow = "7px -3px 5px rgba(88,88,88,0.7)";
    if (a.anchor == undefined) a.anchor = i.BOTTOM;
    this.setValues(c)
  }
  g.prototype = new google.maps.OverlayView;
  window.RichMarker = g;
  g.prototype.getVisible = function () {
    return this.get("visible")
  };
  g.prototype.getVisible = g.prototype.getVisible;
  g.prototype.setVisible = function (a) {
    this.set("visible", a)
  };
  g.prototype.setVisible = g.prototype.setVisible;
  g.prototype.s = function () {
    if (this.c) {
      this.a.style.display = this.getVisible() ? "" : "none";
      this.draw()
    }
  };
  g.prototype.visible_changed = g.prototype.s;
  g.prototype.setFlat = function (a) {
    this.set("flat", !!a)
  };
  g.prototype.setFlat = g.prototype.setFlat;
  g.prototype.getFlat = function () {
    return this.get("flat")
  };
  g.prototype.getFlat = g.prototype.getFlat;
  g.prototype.p = function () {
    return this.get("width")
  };
  g.prototype.getWidth = g.prototype.p;
  g.prototype.o = function () {
    return this.get("height")
  };
  g.prototype.getHeight = g.prototype.o;
  g.prototype.setShadow = function (a) {
    this.set("shadow", a);
    this.g()
  };
  g.prototype.setShadow = g.prototype.setShadow;
  g.prototype.getShadow = function () {
    return this.get("shadow")
  };
  g.prototype.getShadow = g.prototype.getShadow;
  g.prototype.g = function () {
    if (this.c) this.a.style.boxShadow = this.a.style.webkitBoxShadow = this.a.style.MozBoxShadow = this.getFlat() ? "" : this.getShadow()
  };
  g.prototype.flat_changed = g.prototype.g;
  g.prototype.setZIndex = function (a) {
    this.set("zIndex", a)
  };
  g.prototype.setZIndex = g.prototype.setZIndex;
  g.prototype.getZIndex = function () {
    return this.get("zIndex")
  };
  g.prototype.getZIndex = g.prototype.getZIndex;
  g.prototype.t = function () {
    if (this.getZIndex() && this.c) this.a.style.zIndex = this.getZIndex()
  };
  g.prototype.zIndex_changed = g.prototype.t;
  g.prototype.getDraggable = function () {
    return this.get("draggable")
  };
  g.prototype.getDraggable = g.prototype.getDraggable;
  g.prototype.setDraggable = function (a) {
    this.set("draggable", !!a)
  };
  g.prototype.setDraggable = g.prototype.setDraggable;
  g.prototype.k = function () {
    if (this.c) this.getDraggable() ? j(this, this.a) : k(this)
  };
  g.prototype.draggable_changed = g.prototype.k;
  g.prototype.getPosition = function () {
    return this.get("position")
  };
  g.prototype.getPosition = g.prototype.getPosition;
  g.prototype.setPosition = function (a) {
    this.set("position", a)
  };
  g.prototype.setPosition = g.prototype.setPosition;
  g.prototype.q = function () {
    this.draw()
  };
  g.prototype.position_changed = g.prototype.q;
  g.prototype.l = function () {
    return this.get("anchor")
  };
  g.prototype.getAnchor = g.prototype.l;
  g.prototype.r = function (a) {
    this.set("anchor", a)
  };
  g.prototype.setAnchor = g.prototype.r;
  g.prototype.n = function () {
    this.draw()
  };
  g.prototype.anchor_changed = g.prototype.n;

  function l(a, c) {
    var d = document.createElement("DIV");
    d.innerHTML = c;
    if (d.childNodes.length == 1) return d.removeChild(d.firstChild);
    else {
      for (var e = document.createDocumentFragment(); d.firstChild;) e.appendChild(d.firstChild);
      return e
    }
  }

  function m(a, c) {
    if (c)
      for (var d; d = c.firstChild;) c.removeChild(d)
  }
  g.prototype.setContent = function (a) {
    this.set("content", a)
  };
  g.prototype.setContent = g.prototype.setContent;
  g.prototype.getContent = function () {
    return this.get("content")
  };
  g.prototype.getContent = g.prototype.getContent;
  g.prototype.j = function () {
    if (this.b) {
      m(this, this.b);
      var a = this.getContent();
      if (a) {
        if (typeof a == "string") {
          a = a.replace(/^\s*([\S\s]*)\b\s*$/, "$1");
          a = l(this, a)
        }
        this.b.appendChild(a);
        var c = this;
        a = this.b.getElementsByTagName("IMG");
        for (var d = 0, e; e = a[d]; d++) {
          google.maps.event.addDomListener(e, "mousedown", function (h) {
            if (c.getDraggable()) {
              h.preventDefault && h.preventDefault();
              h.returnValue = f
            }
          });
          google.maps.event.addDomListener(e, "load", function () {
            c.draw()
          })
        }
        google.maps.event.trigger(this, "domready")
      }
      this.c &&
        this.draw()
    }
  };
  g.prototype.content_changed = g.prototype.j;

  function n(a, c) {
    if (a.c) {
      var d = "";
      if (navigator.userAgent.indexOf("Gecko/") !== -1) {
        if (c == "dragging") d = "-moz-grabbing";
        if (c == "dragready") d = "-moz-grab"
      } else if (c == "dragging" || c == "dragready") d = "move";
      if (c == "draggable") d = "pointer";
      if (a.a.style.cursor != d) a.a.style.cursor = d
    }
  }

  function o(a, c) {
    if (a.getDraggable())
      if (!a.d) {
        a.d = b;
        var d = a.getMap();
        a.m = d.get("draggable");
        d.set("draggable", f);
        a.h = c.clientX;
        a.i = c.clientY;
        n(a, "dragready");
        a.a.style.MozUserSelect = "none";
        a.a.style.KhtmlUserSelect = "none";
        a.a.style.WebkitUserSelect = "none";
        a.a.unselectable = "on";
        a.a.onselectstart = function () {
          return f
        };
        p(a);
        google.maps.event.trigger(a, "dragstart")
      }
  }

  function q(a) {
    if (a.getDraggable())
      if (a.d) {
        a.d = f;
        a.getMap().set("draggable", a.m);
        a.h = a.i = a.m = null;
        a.a.style.MozUserSelect = "";
        a.a.style.KhtmlUserSelect = "";
        a.a.style.WebkitUserSelect = "";
        a.a.unselectable = "off";
        a.a.onselectstart = function () {};
        r(a);
        n(a, "draggable");
        google.maps.event.trigger(a, "dragend");
        a.draw()
      }
  }

  function s(a, c) {
    if (!a.getDraggable() || !a.d) q(a);
    else {
      var d = a.h - c.clientX,
        e = a.i - c.clientY;
      a.h = c.clientX;
      a.i = c.clientY;
      d = parseInt(a.a.style.left, 10) - d;
      e = parseInt(a.a.style.top, 10) - e;
      a.a.style.left = d + "px";
      a.a.style.top = e + "px";
      var h = t(a);
      a.setPosition(a.getProjection().fromDivPixelToLatLng(new google.maps.Point(d - h.width, e - h.height)));
      n(a, "dragging");
      google.maps.event.trigger(a, "drag")
    }
  }

  function k(a) {
    if (a.f) {
      google.maps.event.removeListener(a.f);
      delete a.f
    }
    n(a, "")
  }

  function j(a, c) {
    if (c) {
      a.f = google.maps.event.addDomListener(c, "mousedown", function (d) {
        o(a, d)
      });
      n(a, "draggable")
    }
  }

  function p(a) {
    if (a.a.setCapture) {
      a.a.setCapture(b);
      a.e = [google.maps.event.addDomListener(a.a, "mousemove", function (c) {
        s(a, c)
      }, b), google.maps.event.addDomListener(a.a, "mouseup", function () {
        q(a);
        a.a.releaseCapture()
      }, b)]
    } else a.e = [google.maps.event.addDomListener(window, "mousemove", function (c) {
      s(a, c)
    }, b), google.maps.event.addDomListener(window, "mouseup", function () {
      q(a)
    }, b)]
  }

  function r(a) {
    if (a.e) {
      for (var c = 0, d; d = a.e[c]; c++) google.maps.event.removeListener(d);
      a.e.length = 0
    }
  }

  function t(a) {
    var c = a.l();
    if (typeof c == "object") return c;
    var d = new google.maps.Size(0, 0);
    if (!a.b) return d;
    var e = a.b.offsetWidth;
    a = a.b.offsetHeight;
    switch (c) {
      case i.TOP:
        d.width = -e / 2;
        break;
      case i.TOP_RIGHT:
        d.width = -e;
        break;
      case i.LEFT:
        d.height = -a / 2;
        break;
      case i.MIDDLE:
        d.width = -e / 2;
        d.height = -a / 2;
        break;
      case i.RIGHT:
        d.width = -e;
        d.height = -a / 2;
        break;
      case i.BOTTOM_LEFT:
        d.height = -a;
        break;
      case i.BOTTOM:
        d.width = -e / 2;
        d.height = -a;
        break;
      case i.BOTTOM_RIGHT:
        d.width = -e;
        d.height = -a
    }
    return d
  }
  g.prototype.onAdd = function () {
    if (!this.a) {
      this.a = document.createElement("DIV");
      this.a.style.position = "absolute"
    }
    if (this.getZIndex()) this.a.style.zIndex = this.getZIndex();
    this.a.style.display = this.getVisible() ? "" : "none";
    if (!this.b) {
      this.b = document.createElement("DIV");
      this.a.appendChild(this.b);
      var a = this;
      google.maps.event.addDomListener(this.b, "click", function () {
        google.maps.event.trigger(a, "click")
      });
      google.maps.event.addDomListener(this.b, "mouseover", function () {
        google.maps.event.trigger(a, "mouseover")
      });
      google.maps.event.addDomListener(this.b, "mouseout", function () {
        google.maps.event.trigger(a, "mouseout")
      })
    }
    this.c = b;
    this.j();
    this.g();
    this.k();
    var c = this.getPanes();
    c && c.overlayImage.appendChild(this.a);
    google.maps.event.trigger(this, "ready")
  };
  g.prototype.onAdd = g.prototype.onAdd;
  g.prototype.draw = function () {
    if (!(!this.c || this.d)) {
      var a = this.getProjection();
      if (a) {
        var c = this.get("position");
        a = a.fromLatLngToDivPixel(c);
        c = t(this);
        this.a.style.top = a.y + c.height + "px";
        this.a.style.left = a.x + c.width + "px";
        a = this.b.offsetHeight;
        c = this.b.offsetWidth;
        c != this.get("width") && this.set("width", c);
        a != this.get("height") && this.set("height", a)
      }
    }
  };
  g.prototype.draw = g.prototype.draw;
  g.prototype.onRemove = function () {
    this.a && this.a.parentNode && this.a.parentNode.removeChild(this.a);
    k(this)
  };
  g.prototype.onRemove = g.prototype.onRemove;
  var i = {
    TOP_LEFT: 1,
    TOP: 2,
    TOP_RIGHT: 3,
    LEFT: 4,
    MIDDLE: 5,
    RIGHT: 6,
    BOTTOM_LEFT: 7,
    BOTTOM: 8,
    BOTTOM_RIGHT: 9
  };
  window.RichMarkerPosition = i;
})();


var mapStyles = [{
  "featureType": "administrative.land_parcel",
  "elementType": "labels",
  "stylers": [{
    "visibility": "off"
  }]
}, {
  "featureType": "poi",
  "elementType": "labels.text",
  "stylers": [{
    "visibility": "off"
  }]
}, {
  "featureType": "poi.business",
  "stylers": [{
    "visibility": "off"
  }]
}, {
  "featureType": "road",
  "elementType": "labels.icon",
  "stylers": [{
    "visibility": "off"
  }]
}, {
  "featureType": "road.local",
  "elementType": "labels",
  "stylers": [{
    "visibility": "off"
  }]
}, {
  "featureType": "transit",
  "stylers": [{
    "visibility": "off"
  }]
}];

// Homepage map - Google

function drawInfobox(infoboxContent, json, i) {
  if (json[i].id) {
    var id = json[i].id
  } else {
    id = ''
  }
  if (json[i].place_id) {
    var place_id = json[i].place_id
  } else {
    place_id = ''
  }
  if (json[i].title) {
    var title = json[i].title
  } else {
    title = ''
  }
  if (json[i].location) {
    var location = json[i].location
  } else {
    location = ''
  }
  if (json[i].city) {
    var city = json[i].city
  } else {
    city = ''
  }
  if (json[i].latitude) {
    var latitude = json[i].latitude
  } else {
    latitude = ''
  }
  if (json[i].longitude) {
    var longitude = json[i].longitude
  } else {
    longitude = ''
  }
  var ibContent = '';
  ibContent =
    '<div class="infobox">' +
    '<div class="inner">' +
    '<div class="image">' +
    '<h6 class="title mb-1">' + title + '</h6>' +
    '<span class="d-block mb-2">' + location + ', ' + city + '.</span>' +
    '<a href="https://www.google.com/maps/search/?api=1&query=Google&query_place_id=' + place_id + '" class="d-inline-block" target="_blank"><i class="fa fa-map-marker" aria-hidden="true"></i> Ver Dirección </a>' +
    '<a href="https://waze.com/ul?ll=' + latitude + ',' + longitude + '&navigate=yes" class="d-inline-block" target="_blank"><i class="fa fa-map-o ml-2" aria-hidden="true"></i> Navegar con Waze' +

    '</div>' +
    '</div>' +
    '</div>';
  return ibContent;
}

export function createHomepageGoogleMap(_latitude, _longitude, zoom, json) {
  gMap();

  function gMap() {
    var mapCenter = new google.maps.LatLng(_latitude, _longitude);
    var mapOptions = {
      zoom: zoom,
      center: mapCenter,
      disableDefaultUI: false,
      scrollwheel: false,
      styles: mapStyles,
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
        position: google.maps.ControlPosition.BOTTOM_CENTER
      },
      panControl: true,
      zoomControl: true,
      zoomControlOptions: {
        style: google.maps.ZoomControlStyle.LARGE,
        position: google.maps.ControlPosition.LEFT_TOP
      }
    };
    var mapElement = document.getElementById('map');
    var map = new google.maps.Map(mapElement, mapOptions);
    var newMarkers = [];
    var markerClicked = 0;
    var activeMarker = false;
    var lastClicked = false;

    for (var i = 0; i < json.length; i++) {

      // Google map marker content 

      var markerContent = document.createElement('DIV');
      if (json[i].featured == 1) {
        markerContent.innerHTML =
          '<div class="map-marker featured">' +
          '<div class="icon">' +
          json[i].id +
          '</div>' +
          '</div>';
      } else {
        markerContent.innerHTML =
          '<div class="map-marker">' +
          '<div class="icon">' +
          json[i].id +
          '</div>' +
          '</div>';
      }

      // Create marker on the map -

      var marker = new RichMarker({
        position: new google.maps.LatLng(json[i].latitude, json[i].longitude),
        map: map,
        draggable: false,
        content: markerContent,
        flat: true
      });

      newMarkers.push(marker);

      // Create infobox for marker 

      var infoboxContent = document.createElement("div");
      var infoboxOptions = {
        content: infoboxContent,
        disableAutoPan: false,
        pixelOffset: new google.maps.Size(-18, -42),
        zIndex: null,
        alignBottom: true,
        boxClass: "infobox",
        enableEventPropagation: true,
        closeBoxMargin: "0px 0px -30px 0px",
        // closeBoxURL: "x",
        infoBoxClearance: new google.maps.Size(1, 1)
      };

      // Infobox HTML element 

      // var category = json[i].category;
      infoboxContent.innerHTML = drawInfobox(infoboxContent, json, i);

      // Create new markers 

      newMarkers[i].infobox = new InfoBox(infoboxOptions);

      // Show infobox after click

      google.maps.event.addListener(marker, 'click', (function (marker, i) {
        return function () {
          google.maps.event.addListener(map, 'click', function (event) {
            lastClicked = newMarkers[i];
          });
          activeMarker = newMarkers[i];
          if (activeMarker != lastClicked) {
            for (var h = 0; h < newMarkers.length; h++) {
              newMarkers[h].content.className = 'marker-loaded';
              newMarkers[h].infobox.close();
            }
            newMarkers[i].infobox.open(map, this);
            newMarkers[i].infobox.setOptions({
              boxClass: 'fade-in-marker'
            });
            newMarkers[i].content.className = 'marker-active marker-loaded';
            markerClicked = 1;
          }
        }
      })(marker, i));

      // Fade infobox after close is clicked 

      google.maps.event.addListener(newMarkers[i].infobox, 'closeclick', (function (marker, i) {
        return function () {
          activeMarker = 0;
          newMarkers[i].content.className = 'marker-loaded';
          newMarkers[i].infobox.setOptions({
            boxClass: 'fade-out-marker'
          });
        }
      })(marker, i));
    }

    // Close infobox after click on map 

    google.maps.event.addListener(map, 'click', function (event) {
      if (activeMarker != false && lastClicked != false) {
        if (markerClicked == 1) {
          activeMarker.infobox.open(map);
          activeMarker.infobox.setOptions({
            boxClass: 'fade-in-marker'
          });
          activeMarker.content.className = 'marker-active marker-loaded';
        } else {
          markerClicked = 0;
          activeMarker.infobox.setOptions({
            boxClass: 'fade-out-marker'
          });
          activeMarker.content.className = 'marker-loaded';
          setTimeout(function () {
            activeMarker.infobox.close();
          }, 350);
        }
        markerClicked = 0;
      }
      if (activeMarker != false) {
        google.maps.event.addListener(activeMarker, 'click', function (event) {
          markerClicked = 1;
        });
      }
      markerClicked = 0;
    });

    // Dynamic loading markers and data from JSON 

    google.maps.event.addListener(map, 'idle', function () {
      var visibleArray = [];
      for (var i = 0; i < json.length; i++) {
        if (map.getBounds().contains(newMarkers[i].getPosition())) {
          visibleArray.push(newMarkers[i]);
          $.each(visibleArray, function (i) {
            setTimeout(function () {
              if (map.getBounds().contains(visibleArray[i].getPosition())) {
                if (!visibleArray[i].content.className) {
                  visibleArray[i].setMap(map);
                  visibleArray[i].content.className += 'marker-loaded';
                  // markerCluster.repaint();
                }
              }
            }, i * 50);
          });
        } else {
          newMarkers[i].content.className = '';
          newMarkers[i].setMap(null);
        }
      }

      var visibleItemsArray = [];
      $.each(json, function (a) {
        if (map.getBounds().contains(new google.maps.LatLng(json[a].latitude, json[a].longitude))) {
          pushItemsToArray(json, a, visibleItemsArray);
        }
      });

      // Create list of items in Results sidebar 

      $('.items-list .results').html(visibleItemsArray);

      var $singleItem = $('.results .item');
      $singleItem.hover(
        function () {
          newMarkers[$(this).attr('id') - 1].content.className = 'marker-active marker-loaded';
        },
        function () {
          newMarkers[$(this).attr('id') - 1].content.className = 'marker-loaded';
        }
      );
    });

    // redrawMap('google', map);

    function success(position) {
      var locationCenter = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
      map.setCenter(locationCenter);
      map.setZoom(14);

      var markerContent = document.createElement('DIV');
      markerContent.innerHTML =
        '<div class="map-marker">' +
        '<div class="icon">' +
        '</div>' +
        '</div>';

      // Create marker on the map 

      var marker = new RichMarker({
        position: locationCenter,
        map: map,
        draggable: false,
        content: markerContent,
        flat: true
      });

      marker.content.className = 'marker-loaded';

      var geocoder = new google.maps.Geocoder();
      geocoder.geocode({
        "latLng": locationCenter
      }, function (results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
          var lat = results[0].geometry.location.lat(),
            lng = results[0].geometry.location.lng(),
            placeName = results[0].address_components[0].long_name,
            latlng = new google.maps.LatLng(lat, lng);

          $("#location").val(results[0].formatted_address);
        }
      });

    }
  }
}

// Push items to array and create <li> element in Results sidebar 

function pushItemsToArray(json, a, visibleItemsArray) {
  var itemPhone;
  visibleItemsArray.push(
    '<li class="border-bottom py-3">' +
    '<div class="item small lh-22" id="' + json[a].id + '">' +
    '<div class="wrapper">' +
    '<h6 class="mb-1 h5">' + json[a].id + '. ' + json[a].title + '</h6>' +
    '<span>' + json[a].location + ', ' + json[a].city + '.</span>' +
    '<a href="tel:' + drawPhone(json[a].telephone) + '" class="d-block"> <i class="fa fa-phone" aria-hidden="true"></i> ' + drawPhone(json[a].telephone) + '</a>' +
    '<div class="info">' +
    '<span class="type">' +
    '<i class="fa fa-map-marker" aria-hidden="true"></i> <a href="https://www.google.com/maps/search/?api=1&query=Google&query_place_id=' + json[a].place_id + '" class="description" target="_blank"> Ver Dirección </a>' +
    '</span>' +
    '<span class="type">' +
    '<i class="fa fa-map-o ml-2" aria-hidden="true"></i> <a href="https://waze.com/ul?ll=' + json[a].latitude + ',' + json[a].longitude + '&navigate=yes" class="description" target="_blank"> Navegar con Waze </a>' +

    '</span>' +
    '</div>' +
    '</div>' +
    '</div>' +
    '</li>'
  );

  function drawPhone(phone) {
    if (phone) {
      itemPhone = phone;
      return itemPhone;
    } else {
      return '';
    }
  }
}

// Redraw map after item list is closed 

// function redrawMap(mapProvider, map) {
//   $('.map .toggle-navigation').click(function () {
//     $('.map-canvas').toggleClass('results-collapsed');
//     $('.map-canvas .map').one("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd", function () {
//       google.maps.event.trigger(map, 'resize');
//     });
//   });
// }



// WEBPACK FOOTER //
// ./src/scripts/vendor/maps.js